import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

let store = new Vuex.Store({
    state: {
        isMainPage: true,
        isLoading: true,
        apiUrl: "https://shop.okraina.ru"
    },
    mutations : {
        SET_MAIN_PAGE: (state, value) => {
            state.isMainPage = value;
        },
        SET_LOADING: (state, value) => {
            state.isLoading = value;
        },
    },
    actions: {
        SET_MAIN_PAGE({commit}, value) {
            commit('SET_MAIN_PAGE', value);
        },
        SET_LOADING({commit}, value) {
            commit('SET_LOADING', value);
        },
    },
    getters: {
        IS_MAIN_PAGE(state) {
            return state.isMainPage;
        },
        API_URL(state) {
            return state.apiUrl;
        }
    }

});

export default store;